module.exports = __webpack_public_path__ + "510784eaa482e4f724568b8938fa585d.png";